// src/components/BrokerCRM/steps/PropertyStep.js
import React, { useState, useEffect } from "react";
import styles from "../BrokerCRM.module.css";

function PropertyStep({ data = {}, updateCrmData }) {
  const [formData, setFormData] = useState({
    applicationType: data.applicationType || "",
    propertyAddress: data.propertyAddress || "",
    preApproval: data.preApproval || "",
    firstHomeBuyer: data.firstHomeBuyer || "",
    purchasePrice: data.purchasePrice || "",
    depositAmount: data.depositAmount || "",
    buyingWith: data.buyingWith || "No",
    currentLoanBalance: data.currentLoanBalance || "",
    currentInterestRate: data.currentInterestRate || "",
    estimatedPropertyValue: data.estimatedPropertyValue || "",
  });

  // Sync with crmData whenever local changes
  useEffect(() => {
    updateCrmData(formData);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Application type handler
  const handleTypeSelect = (type) => {
    setFormData((prev) => ({
      ...prev,
      applicationType: type,
    }));
  };

  return (
    <div className={styles.formSection}>
      <h2>Property Details</h2>

      {/* Toggle buttons */}
      <div className={styles.buttonGroup}>
        <button
          type="button"
          className={`${styles.toggleButton} ${
            formData.applicationType === "purchase" ? styles.active : ""
          }`}
          onClick={() => handleTypeSelect("purchase")}
        >
          🏡 Purchase
        </button>
        <button
          type="button"
          className={`${styles.toggleButton} ${
            formData.applicationType === "refinance" ? styles.active : ""
          }`}
          onClick={() => handleTypeSelect("refinance")}
        >
          💰 Refinance
        </button>
      </div>

      {/* PURCHASE FORM */}
      {formData.applicationType === "purchase" && (
        <div className={styles.formGrid}>
          <div className={styles.fullWidth}>
            <label>Property Address</label>
            <input
              type="text"
              name="propertyAddress"
              value={formData.propertyAddress}
              onChange={handleChange}
              placeholder="Enter address"
            />
          </div>

          <div className={styles.formRow}>
            <div className={styles.formColumn}>
              <label>Purchase Price</label>
              <input
                type="number"
                name="purchasePrice"
                value={formData.purchasePrice}
                onChange={handleChange}
                placeholder="$"
              />
            </div>
            <div className={styles.formColumn}>
              <label>Deposit Amount</label>
              <input
                type="number"
                name="depositAmount"
                value={formData.depositAmount}
                onChange={handleChange}
                placeholder="$"
              />
              {/* LVR logic */}
              {formData.purchasePrice && formData.depositAmount && (
                <small>
                  {(() => {
                    const lvr =
                      100 -
                      (formData.depositAmount / formData.purchasePrice) * 100;
                    const color =
                      lvr > 95 ? "red" : lvr > 80 ? "orange" : "green";
                    return (
                      <span style={{ color }}>
                        LVR: {lvr.toFixed(1)}%
                      </span>
                    );
                  })()}
                </small>
              )}
            </div>
          </div>

          <div className={styles.formRow}>
            <div className={styles.formColumn}>
              <label>Do you already have Pre-Approval?</label>
              <select
                name="preApproval"
                value={formData.preApproval}
                onChange={handleChange}
              >
                <option value="">-- Select --</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>
            <div className={styles.formColumn}>
              <label>Are you a First Home Buyer?</label>
              <select
                name="firstHomeBuyer"
                value={formData.firstHomeBuyer}
                onChange={handleChange}
              >
                <option value="">-- Select --</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>
          </div>

          <div className={styles.formRow}>
            <div className={styles.formColumn}>
              <label>Buying with someone else?</label>
              <select
                name="buyingWith"
                value={formData.buyingWith}
                onChange={handleChange}
              >
                <option>No</option>
                <option>Yes</option>
              </select>
            </div>
          </div>
        </div>
      )}

      {/* REFINANCE FORM */}
      {formData.applicationType === "refinance" && (
        <div className={styles.formGrid}>
          <div className={styles.fullWidth}>
            <label>Property Address</label>
            <input
              type="text"
              name="propertyAddress"
              value={formData.propertyAddress}
              onChange={handleChange}
              placeholder="Enter address"
            />
          </div>

          <div className={styles.formRow}>
            <div className={styles.formColumn}>
              <label>Estimated Property Value</label>
              <input
                type="number"
                name="estimatedPropertyValue"
                value={formData.estimatedPropertyValue}
                onChange={handleChange}
                placeholder="$"
              />
            </div>
            <div className={styles.formColumn}>
              <label>Current Loan Balance</label>
              <input
                type="number"
                name="currentLoanBalance"
                value={formData.currentLoanBalance}
                onChange={handleChange}
                placeholder="$"
              />
              {/* Refinance LVR */}
              {formData.estimatedPropertyValue &&
                formData.currentLoanBalance && (
                  <small>
                    {(() => {
                      const lvr =
                        (formData.currentLoanBalance /
                          formData.estimatedPropertyValue) *
                        100;
                      const color =
                        lvr > 95 ? "red" : lvr > 80 ? "orange" : "green";
                      return (
                        <span style={{ color }}>
                          LVR: {lvr.toFixed(1)}%
                        </span>
                      );
                    })()}
                  </small>
                )}
            </div>
          </div>

          <div className={styles.formRow}>
            <div className={styles.formColumn}>
              <label>Current Interest Rate</label>
              <input
                type="number"
                name="currentInterestRate"
                value={formData.currentInterestRate}
                onChange={handleChange}
                placeholder="%"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PropertyStep;
